import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "avatarUpload" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_4218_12688)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6.75 2.24989H11.25L12.75 3.74989H15.75C15.9489 3.74989 16.1397 3.82891 16.2803 3.96956C16.421 4.11022 16.5 4.30098 16.5 4.49989V14.9999C16.5 15.1988 16.421 15.3896 16.2803 15.5302C16.1397 15.6709 15.9489 15.7499 15.75 15.7499H2.25C2.05109 15.7499 1.86032 15.6709 1.71967 15.5302C1.57902 15.3896 1.5 15.1988 1.5 14.9999V4.49989C1.5 4.30098 1.57902 4.11022 1.71967 3.96956C1.86032 3.82891 2.05109 3.74989 2.25 3.74989H5.25L6.75 2.24989ZM9 14.2499C10.1935 14.2499 11.3381 13.7758 12.182 12.9319C13.0259 12.088 13.5 10.9434 13.5 9.74989C13.5 8.55642 13.0259 7.41183 12.182 6.56791C11.3381 5.724 10.1935 5.24989 9 5.24989C7.80653 5.24989 6.66193 5.724 5.81802 6.56791C4.97411 7.41183 4.5 8.55642 4.5 9.74989C4.5 10.9434 4.97411 12.088 5.81802 12.9319C6.66193 13.7758 7.80653 14.2499 9 14.2499ZM9 12.7499C8.20435 12.7499 7.44129 12.4338 6.87868 11.8712C6.31607 11.3086 6 10.5455 6 9.74989C6 8.95424 6.31607 8.19118 6.87868 7.62857C7.44129 7.06596 8.20435 6.74989 9 6.74989C9.79565 6.74989 10.5587 7.06596 11.1213 7.62857C11.6839 8.19118 12 8.95424 12 9.74989C12 10.5455 11.6839 11.3086 11.1213 11.8712C10.5587 12.4338 9.79565 12.7499 9 12.7499Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_4218_12688" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "18",
        height: "18",
        fill: "white"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_avatar, { preview: _ctx.preview }, {
      icon: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["preview"]),
    _createElementVNode("input", {
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fileUpload && _ctx.fileUpload(...args))),
      class: "avatarUpload_input",
      type: "file",
      accept: "image/*"
    }, null, 32)
  ]))
}